import fvSubassembly from "../fvSubassembly"
export default class fvArcObj extends fvSubassembly {
    constructor(sContent,parent,system,callback){
        super(sContent,parent,system);
        this.create();
        if(this.isDelayedWaiting){
            this.complete = callback;
        }else{
            callback(this);
        }
        this.createSucss();
        this.isHide = true;
        if(this.animation.fvHide){
            this.isHide = false;
        }
    }
	init(){
	    super.init();
	    this.moveWidth = this.borderWidth / 2;
	}
    onDraw(canvas){
        this.setCanvas(canvas)
        if(!this.isHide) return;
        if(!this.fcHide) return;
        this.formatRect();
        this.executePreAnimation(canvas);
        canvas.save()
        if(parseFloat(this.width) > parseFloat(this.height)){
            this.scaleX = 1;
            this.scaleY = parseFloat(this.height)/parseFloat(this.width);
            this.radius = parseFloat(this.width);
            this.wh = this.width;
        }else{
            this.scaleY = 1;
            this.scaleX = parseFloat(this.width)/parseFloat(this.height);
            this.radius = parseFloat(this.height);
            this.wh = this.height;
        }
        // canvas.fillStyle = "#EFC93C";//矩形填充颜色
        // canvas.fillRect(0,0,this.width,this.height);//矩形坐标及大小
        this.centerX = (this.cx + parseFloat(this.width))/this.scaleX;
        this.centerY = (this.cy + parseFloat(this.height))/this.scaleY;
        if(this.borderWidth == 1){
            canvas.setLineDash(this.lineStyle(this.lineType));
        }
        canvas.beginPath();
        canvas.scale(this.scaleX, this.scaleY);
        canvas.strokeStyle = this.borderColor;
        // canvas.scale(this.scaleX, this.scaleY);
        switch (this.centerDirection)
        {
            //圆心以右上角为基准
            case "rightBottom":
                canvas.arc(this.centerX-this.wh,this.centerY-this.wh,this.radius,0,Math.PI/2,false);
                break;
            //圆心以左下角为基准
            case "leftBottom":
                canvas.arc(this.centerX+this.borderWidth/2,this.centerY-this.wh,this.radius,Math.PI/2,Math.PI,false);
                break;
            //圆心以右上角为基准
            case "rightTop":
                canvas.arc(this.centerX-this.wh,this.centerY+this.borderWidth/2,this.radius,Math.PI *1.5,0,false);
                break;
            //圆心以左上角为基准
            case "leftTop":
                canvas.arc(this.centerX+this.borderWidth/2,this.centerY+this.borderWidth/2,this.radius,Math.PI,Math.PI *1.5,false);
                break;
            default :
                break;
        }
        canvas.stroke();
        canvas.closePath();
        this.Render(canvas);
        canvas.restore();
        this.executePosAnimation(canvas)
    }
}


// WEBPACK FOOTER //
// ./src/js/canvas/subUnit/fvArcObj.js